import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, Typography, withStyles } from '@material-ui/core'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Snackbars from "components/Snackbar/Snackbar.js";
import { editMovement } from 'redux/actions/gasMovements/gasMovActions'
import { createNewMovement } from 'redux/actions/gasMovements/gasMovActions'
//import { deleteMovement } from 'redux/actions/gasMovements/gasMovActions'

const blue = '#0055aa'

const CustomFormControlLabel = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  label: {
    margin: 0,
    color: "grey"
  }
})(FormControlLabel);

export const FormGasMovEdit = (props) => {
  const { handleClose } = props
  const { movementSelected, addMode, deleteMode } = useSelector(state => state.gasMovements)
  const [snackBar, setSnackBar] = useState(false)
  const [visibleRegister, setVisibleRegister] = useState(false)
  const [visibleInventory, setVisibleInventory] = useState(false)
  const [affectsLiterCounter, setAffectsLiterCounter] = useState(false)
  const [type, setType] = useState('')
  const [movementType, setMovementType] = useState('')
  const [isWholesaler, setIsWholesaler] = useState(false)
  const { token } = useSelector(state => state.login)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    code: '',
    movement: '',
    description: '',
    inventoryType: '',
  })
  const dispatch = useDispatch()
  const { code, movement, description, inventoryType } = inputValues

  const handleSubmit = async () => {
    // if(deleteMode){
    //   dispatch(deleteMovement(movementSelected.code, token))
    //   handleClose()
    //   return
    // } 

    const newValues = {
      ...movementSelected,
      code: parseInt(code),
      movement,
      movementType,
      type,
      description,
      visibleRegister: visibleRegister ? 1 : 0,
      visibleInventory: visibleInventory ? 1 : 0,
      affectsLiterCounter: affectsLiterCounter ? 1 : 0,
      isWholesaler: isWholesaler ? 1 : 0,
      inventoryType,
    }

    if (code && movement.length > 0 && movementType.length > 0 && type.length > 0 && inventoryType.length > 0) {
      if (addMode) {
        dispatch(createNewMovement(newValues, token))
        handleClose()
      } else {
        dispatch(editMovement(movementSelected.id, newValues, token))
        handleClose()
      }
    } else {
      setSnackBar(true)
    }
  }

  useEffect(() => {
    if (movementSelected) {
      handleNewValues({
        code: movementSelected.code,
        movement: movementSelected.movement,
        description: movementSelected.description,
        inventoryType: movementSelected.inventoryType
      })
      setType(movementSelected.type)
      setMovementType(movementSelected.movementType)
      setVisibleRegister(movementSelected.visibleRegister === 1 ? true : false)
      setVisibleInventory(movementSelected.visibleInventory === 1 ? true : false)
      setAffectsLiterCounter(movementSelected.affectsLiterCounter === 1 ? true : false)
      setIsWholesaler(movementSelected.isWholesaler === 1 ? true : false)
    }
    // eslint-disable-next-line
  }, [movementSelected])

  return (
    <>
      <Typography component="h2">
        {
          addMode
            ? 'Agregar nuevo movimiento'
            : deleteMode ? '¿Estas seguro de eliminar este movimiento?'
              : 'Modificar movimiento'
        }
      </Typography>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
        <TextField type="text" label="Clave *" name="code" value={code} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <TextField type="text" label="Movimiento *" name="movement" value={movement} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <FormControl fullWidth variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label">Tipo de Movimiento *</InputLabel>
          <Select
            id="demo-simple-select-outlined"
            value={movementType}
            onChange={(e) => setMovementType(e.target.value)}
            label="Tipo de Movimiento *"
            disabled={deleteMode}
          >
            <MenuItem value="">
              <em>Seleccione un tipo de movimiento</em>
            </MenuItem>
            <MenuItem value="ENTRADA">ENTRADA</MenuItem>
            <MenuItem value="SALIDA">SALIDA</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label">Tipo de Unidad *</InputLabel>
          <Select
            id="demo-simple-select-outlined"
            value={type}
            onChange={(e) => setType(e.target.value)}
            label="Tipo de Unidad *"
            disabled={deleteMode}
          >
            <MenuItem value="">
              <em>Seleccione un tipo de unidad</em>
            </MenuItem>
            <MenuItem value="ESTACIONARIO">ESTACIONARIO</MenuItem>
            <MenuItem value="ESTACION">ESTACION</MenuItem>
            <MenuItem value="PORTATIL">PORTATIL</MenuItem>
            <MenuItem value="TODOS">TODOS</MenuItem>
            <MenuItem value="OTROS">OTROS</MenuItem>
          </Select>
        </FormControl>
        <TextField type="text" label="Tipo de Inventario *" name="inventoryType" value={inventoryType} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <TextField type="text" label="Descripción" name="description" value={description} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <CustomFormControlLabel control={<Checkbox name="affectsLiterCounter" onChange={() => setAffectsLiterCounter(!affectsLiterCounter)} checked={affectsLiterCounter} disabled={deleteMode} color='primary' />} labelPlacement="start" label="Afecta Cuenta Litros" />
        <CustomFormControlLabel control={<Checkbox name="isWholesaler" onChange={() => setIsWholesaler(!isWholesaler)} checked={isWholesaler} disabled={deleteMode} color='primary' />} labelPlacement="start" label="Es Mayorista" />
        <CustomFormControlLabel control={<Checkbox name="visibleRegister" onChange={() => setVisibleRegister(!visibleRegister)} checked={visibleRegister} disabled={deleteMode} color='primary' />} labelPlacement="start" label="Visible en Caja" />
        <CustomFormControlLabel control={<Checkbox name="visibleInventory" onChange={() => setVisibleInventory(!visibleInventory)} checked={visibleInventory} disabled={deleteMode} color='primary' />} labelPlacement="start" label="Visible en Inventario" />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 30 }}>
          <RegularButton size="large" variant="contained" color="danger" onClick={handleClose}>Cancelar</RegularButton>
          <RegularButton
            size="large"
            variant="contained"
            color="facebook"
            style={{ backgroundColor: blue, color: 'white' }}
            onClick={handleSubmit}

          >
            {
              addMode
                ? 'Agregar'
                : deleteMode ? 'Eliminar'
                  : 'Guardar'
            }
          </RegularButton>
        </Box>
      </FormControl>
      <Snackbars
        place="tr"
        color='danger'
        message="Campos con * son requeridos"
        open={snackBar}
        closeNotification={() => setSnackBar(false)}
        close
      />
    </>
  )
}
